<template>
  <div class="home">
    <v-container fill-height fluid>
      <v-layout align-center justify-center>
        <v-flex lg9>
          <Login />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Login from '../components/Login.vue'

export default {
  components: {
    Login
  }
}
</script>

<style scoped>
.home {
  height: 100%;
  width: 100%;
  /* Images from https://www.pexels.com/ */
  background-image: url(../assets/background.jpg);
  /* background: url(../assets/building-clouds-facade-412842.jpg); */
  background-position: center;
  background-size: cover;
}
</style>
